import { Box, Button, HStack, Icon } from "@chakra-ui/react";
import type { DefaultTFuncReturn } from "i18next";
import { useTranslation } from "react-i18next";
import { FiCheck, FiX } from "react-icons/fi";

interface Props {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  isReadOnly?: boolean;
  isPositiveDisabled?: boolean;
  positiveLabel?: DefaultTFuncReturn;
  negativeLabel?: DefaultTFuncReturn;
}

export const QualificationVerdictControl = ({
  value,
  onChange,
  isReadOnly,
  isPositiveDisabled,
  positiveLabel,
  negativeLabel,
}: Props) => {
  const { t } = useTranslation();

  const select = (next: boolean) => {
    if (isReadOnly) return;
    if (next === true && isPositiveDisabled) return;
    onChange(value === next ? null : next);
  };

  return (
    <HStack spacing="1" bg="smBackgroundSecondary" borderRadius="md" p="1" align="center">
      <VerdictButton
        active={value === true}
        activeColor="smSuccess"
        icon={FiCheck}
        label={positiveLabel ?? t("Fulfilled")}
        onClick={() => select(true)}
        isReadOnly={isReadOnly || isPositiveDisabled}
      />
      <VerdictButton
        active={value === false}
        activeColor="smError"
        icon={FiX}
        label={negativeLabel ?? t("Not fulfilled")}
        onClick={() => select(false)}
        isReadOnly={isReadOnly}
      />
    </HStack>
  );
};

interface VerdictButtonProps {
  active: boolean;
  activeColor: string;
  icon: typeof FiCheck;
  label: string;
  onClick: () => void;
  isReadOnly?: boolean;
}

const VerdictButton = ({ active, activeColor, icon, label, onClick, isReadOnly }: VerdictButtonProps) => (
  <Button
    size="sm"
    variant="ghost"
    onClick={onClick}
    isDisabled={isReadOnly}
    aria-pressed={active}
    bg={active ? "smBackground" : "transparent"}
    boxShadow={active ? "sm" : "none"}
    color={active ? activeColor : "smMuted"}
    fontWeight="medium"
    _hover={{
      bg: active ? "smBackground" : "smBackgroundSecondary",
      color: active ? activeColor : "smText",
    }}
    px="3"
    h="8"
  >
    <Icon as={icon} mr="1.5" />
    <Box as="span">{label}</Box>
  </Button>
);
